import type {TriggerIntegrationConfigComponentProps} from '@cohort/merchants/apps';
import {SelectPicker} from '@cohort/merchants/components/form/select/SelectPicker';
import {capitalize} from '@cohort/merchants/lib/Utils';
import type {StravaBeActiveTriggerStruct} from '@cohort/shared/apps/strava/triggers/beActive';
import {StravaBeActiveTriggerConfigMetricSchema} from '@cohort/shared/apps/strava/triggers/beActive';
import {useController} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

const StravaMetricSelectPicker: React.FC<
  TriggerIntegrationConfigComponentProps<StravaBeActiveTriggerStruct>
> = ({formReturn: {control}}) => {
  const {t} = useTranslation('app-strava', {
    keyPrefix: 'triggerIntegrations.be-active.configComponent',
  });

  const availableMetrics = StravaBeActiveTriggerConfigMetricSchema.options.map(metric => ({
    value: metric,
    label: capitalize(metric),
  }));
  const {field: metric, fieldState: metricState} = useController({
    control,
    name: 'trigger.triggerIntegrationConfig.metric',
  });

  return (
    <SelectPicker
      value={{value: metric.value, label: metric.value ? capitalize(metric.value) : null}}
      label={t('labelActivityMetric')}
      options={availableMetrics}
      onChange={option => metric.onChange(option?.value ?? '')}
      name="trigger.triggerIntegrationConfig.metric"
      error={metricState.error?.message}
    />
  );
};

export default StravaMetricSelectPicker;
